import { startMonitoring } from './monitoring';

// Measure from the earliest client entrypoint import, before rendering.
startMonitoring();
